<template>
  <qx-card title="货源详情">
    <section class="detail-item-title">
      <div class="detail-item-title-l">
        <span>货源：</span>
        <span>{{ orderDetail.base && orderDetail.base.orderId }}</span>
      </div>
<!--      <div class="detail-item-title-r warning">-->
<!--        {{ orderDetail.base && orderDetail.base.orderStateName }}-->
<!--      </div>-->
    </section>
    <qx-detail-box :data="detailData.base">
      <section slot="sourceName" slot-scope="prop">
        <section>
          <template
            v-if="prop.data.sourceId !== null && prop.data.sourceId > 0"
          >
            <span>{{ prop.data.sourceCode }}</span>
          </template>
          <template
            v-if="prop.data.sourceId == null || prop.data.sourceId <= 0"
          >
            <span>无（临时线路）</span>
          </template>
          <span>{{ ' ' + prop.data.sourceName }}</span>
        </section>
        <section
          class="error"
          v-if="
            orderDetail.baseVer &&
            prop.data.sourceCode !== orderDetail.baseVer.sourceCode
          "
        >
          修改为：
          <span>{{ orderDetail.baseVer.sourceCode || '无（临时线路）' }}</span>
          <span>{{ ' ' + orderDetail.baseVer.sourceName }}</span>
        </section>
      </section>

      <section slot="lineDetail">
        <LineDetail :lineDetail="lineDetail" />
      </section>

      <section slot="unloadDetail">
        <UnloadDetail
          :cityCustomerOrders="cityCustomerOrders"
          :cityCustomerOrderVers="cityCustomerOrderVers"
        />
      </section>

      <section slot="customerDetail">
        <DetailItem
          :detailItemList="customerDetailItemList"
          :orderDetail="orderDetail"
          propName="customerDetail"
        />
      </section>

      <section slot="carriageDetail">
        <DetailItem
          :detailItemList="carriageDetailItemList"
          :orderDetail="orderDetail"
          propName="carriageDetail"
        />
      </section>

      <section slot="incomeDetail">
        <div class="detail-item-inline-box">
          <div
            class="detail-item-horizontal"
            v-for="(item, index) in incomeDetailItemList"
            :key="index"
          >
            <DetailItem
              :detailItemList="item"
              :orderDetail="orderDetail"
              propName="incomeDetail"
              :detailItemHorizontal="true"
            />
          </div>
        </div>
      </section>
    </qx-detail-box>
  </qx-card>
</template>

<script>
import DetailItem from './components/detailItem';
import LineDetail from 'components/lineDetail/lineDetail';
import UnloadDetail from './components/unloadDetail';
export default {
  components: {
    DetailItem,
    LineDetail,
    UnloadDetail,
  },
  data () {
    return {
      orderDetail: {},
      lineDetail: {},
      // 城市配送卸货点列表
      cityCustomerOrders: {},
      // 需要审核的城市配送卸货点列表
      cityCustomerOrderVers: {},
      customerDetailItemList: [
        { label: '客户公里数', value: 'distance' },
        { label: '客户联系人', value: 'linkName' },
        { label: '联系人电话', value: 'linkPhone' },
        { label: '客户地址', value: 'address' },
        { label: '客户单号', value: 'customNumber' },
        { label: '客户合同', value: 'clientContractUrl', type: 'img' },
      ],
      carriageDetailItemList: [
        { label: '承运方公里数', value: 'mileageNumber' },
        { label: '货品名称', value: 'goodsName' },
        { label: '货品类型', value: 'goodsTypeName' },
        { label: '体积', value: 'square' },
        { label: '重量', value: 'weight' },
        { label: '车辆类型', value: 'vehicleType' },
        { label: '计划数量', value: 'goodsNumber'},
      ],
      incomeDetailItemList: [
        [
          { label: '加班车', value: 'isUrgentName' },
          { label: '收入金额', value: 'costPrice' },
          { label: '收入单价', value: 'priceUnit' },
        ],
        [
          { label: '预付现金', value: 'prePayCash' },
          // { label: '等值卡额', value: 'prePayEquivalenceCardAmount' },
          // { label: '等值卡', value: 'prePayEquivalenceCardNumber' },
        ],
        [
          { label: '尾款现金', value: 'afterPayCash' },
          // { label: '等值卡额', value: 'afterPayEquivalenceCardAmount' },
          // { label: '等值卡', value: 'afterPayEquivalenceCardNumber' },
        ],
        [
          { label: '结算方式', value: 'balanceTypeName' },
          { label: '回单期限', value: 'incomeReciveTime' },
          { label: '收款期限', value: 'incomeCollectionTime' },
        ],
      ],
      detailData: {
        base: {
          label: '',
          tableData: {
            title: [
              { prop: 'opName', label: '录入人员' },
              { prop: 'sourceName', label: '线路', slot: true },
              { prop: 'companyName', label: '客户名称' },
              { prop: 'dependTime', label: '发车' },
              // { prop: 'lineDetail', label: '线路信息', slot: true, span: 1, lableHide: true },
              // { prop: 'source', label: '出发地', slot: true, span: 1 },
              { prop: 'customerDetail', label: '客户信息', slot: true, span: 1 },
              { prop: 'carriageDetail', label: '运货信息', slot: true, span: 1 },
              { prop: 'incomeDetail', label: '收入信息', slot: true, span: 1 },
            ],
            data: {
            },
            approveData: {
            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  methods: {
    // 详情数据（用来展示）
    setBaseData (detailRes) {
      const orderGoods = detailRes.orderGoods;
      const orderScheduler = detailRes.orderScheduler;
      const orderInfo = detailRes.orderInfo;
      const orderFee = detailRes.orderFee;
      const incomePaymentDaysInfo = detailRes.incomePaymentDaysInfo || {};
      const transitLineInfos = detailRes.transitLineInfos || [];

      const orderTrailer = detailRes.orderTrailer;
      const opName = `${detailRes.updateBy}${orderInfo.createDate ? (' / ' + orderInfo.createDate.substring(2, 16)) : '--'}`;

      let insertArr = [];
      for (let item of this.detailData.base.tableData.title) {
        if (item.prop === 'dependTime') {
          if (orderInfo.sourceFlag === 14) {
            item.label = '装货时间';
            insertArr = [
              { prop: 'source', label: '出发地', span: 1 },
              { prop: 'unloadDetail', label: '卸货信息', slot: true, span: 1, lableHide: true },
            ];
          } else {
            item.label = '发车';
            insertArr = [
              { prop: 'lineDetail', label: '线路信息', slot: true, span: 1, lableHide: true },
            ];
          }
        }
      }

      const insertStartIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'dependTime') + 1;
      const insertEndIndex = this.detailData.base.tableData.title.findIndex((item) => item.prop === 'customerDetail');
      this.detailData.base.tableData.title.splice(insertStartIndex, insertEndIndex - insertStartIndex, ...insertArr);

      this.orderDetail.base = {
        orderId: detailRes.id,
        opName,
        sourceId: orderScheduler.sourceId,
        sourceCode: orderScheduler.sourceCode,
        sourceName: orderScheduler.sourceName,
        companyName: orderGoods.companyName,
        dependTime: this.formatDate(orderScheduler.dependTime, 4),
        orderStateName: orderInfo.orderStateName,
        lineDetail: this.getLineDetailData(orderScheduler, orderGoods, transitLineInfos),
        customerDetail: this.getCustomerDetailData(orderScheduler, orderGoods),
        carriageDetail: this.getCarriageDetailData(orderTrailer, orderScheduler, orderGoods),
        incomeDetail: this.getIncomeDetailData(orderScheduler, orderFee, incomePaymentDaysInfo),
        sourceFlag: orderInfo.sourceFlag,
        source: orderGoods.source,
      };

      // 将对应模块的 详情数据 赋给 data 即可展示在页面上展示
      this.detailData.base.tableData.data = this.orderDetail.base;
    },
    // 审核数据（用来和 详情数据 做对比，如果和 详情数据不一样，则提示）
    setBaseVerData (detailRes) {
      const orderGoods = detailRes.orderGoodsVer;
      const orderScheduler = detailRes.orderSchedulerVer;
      const orderFee = detailRes.orderFeeVer;
      const incomePaymentDaysInfo = detailRes.incomePaymentDaysInfoVer || {};
      const transitLineInfos = detailRes.transitLineInfoVers || [];
      const isLineChange = this.compareLineDetailData(detailRes);
      const orderTrailer = detailRes.orderTrailerVer;

      this.orderDetail.baseVer = {
        orderId: this.orderDetail.base.orderId, // 不用对比
        opName: this.orderDetail.base.opName, // 不用对比
        sourceId: orderScheduler.sourceId,
        sourceCode: orderScheduler.sourceCode,
        sourceName: orderScheduler.sourceName,
        companyName: orderGoods.companyName,
        dependTime: orderScheduler.dependTime,
        orderStateName: this.orderDetail.base.orderStateName, // 不用对比
        lineDetail: this.getLineDetailData(orderScheduler, orderGoods, transitLineInfos),
        customerDetail: this.getCustomerDetailData(orderScheduler, orderGoods),
        carriageDetail: this.getCarriageDetailData(orderTrailer, orderScheduler, orderGoods),
        incomeDetail: this.getIncomeDetailData(orderScheduler, orderFee, incomePaymentDaysInfo),
        isLineChange,
      };

      // 将对应模块的 审核数据 赋给 approveData 即可自动做对比
      this.detailData.base.tableData.approveData = this.orderDetail.baseVer;
    },
    // 对比线路数据是否有修改，主要对比 起点终点 以及 途经点 的经纬度
    compareLineDetailData (detailRes) {
      let isChange = false;
      // 对比 起点终点 的经纬度
      if (detailRes.orderGoods && detailRes.orderGoodsVer) {
        if (
          (detailRes.orderGoods.nand !== detailRes.orderGoodsVer.nand) ||
          (detailRes.orderGoods.eand !== detailRes.orderGoodsVer.eand) ||
          (detailRes.orderGoods.nandDes !== detailRes.orderGoodsVer.nandDes) ||
          (detailRes.orderGoods.eandDes !== detailRes.orderGoodsVer.eandDes)
        ) {
          isChange = true;
        }
      }
      // 只对比 途经点 的经纬度，其他应该不需要对比，我猜的
      if (
        (detailRes.transitLineInfos && detailRes.transitLineInfos.length) && (detailRes.transitLineInfoVers && detailRes.transitLineInfoVers.length)
      ) {
        const arr1 = detailRes.transitLineInfos.map((item) => ({
          nand: item.nand,
          eand: item.eand,
        }));
        const arr2 = detailRes.transitLineInfoVers.map((item) => ({
          nand: item.nand,
          eand: item.eand,
        }));
        if (JSON.stringify(arr1) !== JSON.stringify(arr2)) {
          isChange = true;
        }
      }
      return isChange;
    },
    getLineDetailData (orderScheduler, orderGoods, transitLineInfos) {
      const addrDtl = orderGoods.addrDtl ? orderGoods.addrDtl.replace(/NaN|undefined|null/g, '') : '';
      const desDtl = orderGoods.desDtl ? orderGoods.desDtl.replace(/NaN|undefined|null/g, '') : '';
      return {
        sourceInfo: {
          addrDtl,
        },
        desInfo: {
          desDtl,
          arriveTime: orderScheduler.arriveTime,
        },
        transitLineInfos,
      };
    },
    // 客户信息
    getCustomerDetailData (orderScheduler, orderGoods) {
      return {
        distance: (orderScheduler.distance / 1000) + 'KM',
        linkName: orderGoods.linkName,
        linkPhone: orderGoods.linkPhone,
        address: orderGoods.address,
        clientContractUrl: orderScheduler.clientContractUrl,
        // clientContractUrl: 'http://10.123.114.53/group1/M00/00/3B/CntyNV_8EOWAZHkpAAAePgVsdLA212_big.jpg?filename=66666666666.jpg',
        customNumber: orderGoods.customNumber,
      };
    },
    // 运货信息
    getCarriageDetailData (orderTrailer, orderScheduler, orderGoods) {
      return {
        mileageNumber: (orderScheduler.mileageNumber / 1000) + 'KM',
        goodsName: orderGoods.goodsName,
        goodsTypeName: orderGoods.goodsTypeName,
        square: orderGoods.square + '立方',
        weight: orderGoods.weight + '吨(' + orderGoods.weight * 1000 + 'KG)',
        // vehicleType: `${orderGoods.vehicleLenghName || '-'}${orderGoods.vehicleStatusName || '-'}`,
        vehicleType: orderTrailer ? orderTrailer.trailerType : '',
        goodsNumber: (orderGoods.nums || '--') + '件',
      };
    },
    // 收入信息
    getIncomeDetailData (orderScheduler, orderFee, incomePaymentDaysInfo) {
      const incomeDetail = {
        isUrgentName: orderScheduler.isUrgent ? '是' : '否',
        costPrice: (orderFee.costPrice / 100) + '元',
        priceUnit: `${orderFee.priceUnit}${orderFee.priceEnumName}`,

        prePayCash: (orderFee.prePayCash / 100) + '元',
        prePayEquivalenceCardAmount: (orderFee.prePayEquivalenceCardAmount) + '元',
        prePayEquivalenceCardNumber: orderFee.prePayEquivalenceCardNumber,

        afterPayCash: (orderFee.afterPayCash / 100) + '元',
        afterPayEquivalenceCardAmount: (orderFee.afterPayEquivalenceCardAmount) + '元',
        afterPayEquivalenceCardNumber: orderFee.afterPayEquivalenceCardNumber,

        balanceTypeName: incomePaymentDaysInfo.balanceTypeName,
      };

      if (incomePaymentDaysInfo.balanceType === 1) {
        // 预付全款
        incomeDetail['incomeReciveTime'] = incomePaymentDaysInfo.reciveTime ? `${incomePaymentDaysInfo.reciveTime}天` : '--';
        incomeDetail['incomeCollectionTime'] = '';
      } else if (incomePaymentDaysInfo.balanceType === 2) {
        // 预付 + 尾款结账 回单期限：x天 收款期限：x天
        incomeDetail['incomeReciveTime'] = incomePaymentDaysInfo.reciveTime ? `${incomePaymentDaysInfo.reciveTime}天` : '--';
        incomeDetail['incomeCollectionTime'] = incomePaymentDaysInfo.collectionTime ? `${incomePaymentDaysInfo.collectionTime}天` : '--';
      } else if (incomePaymentDaysInfo.balanceType === 3) {
        // 预付 + 尾款月结 回单期限：x月后x号 收款期限：x月后x号
        incomeDetail['incomeReciveTime'] = `${incomePaymentDaysInfo.reciveMonth || '-'}个月后${incomePaymentDaysInfo.reciveDay || '-'}号`;
        incomeDetail['incomeCollectionTime'] = `${incomePaymentDaysInfo.collectionMonth || '-'}个月后${incomePaymentDaysInfo.collectionDay || '-'}号`;
      }

      return incomeDetail;
    },
    setLineDetail (detailRes) {
      const orderInfo = detailRes.orderInfo || {};
      const orderGoods = detailRes.orderGoods || {};
      const orderScheduler = detailRes.orderScheduler || {};
      const orderGoodsVer = detailRes.orderGoodsVer || {};
      const orderSchedulerVer = detailRes.orderSchedulerVer || {};
      const subWayList = [];
      const subWayListVer = [];

      if (orderInfo.sourceFlag === 14) {
        // 城市配送订单
      }

      if (detailRes.transitLineInfos && detailRes.transitLineInfos.length) {
        for (let item of detailRes.transitLineInfos) {
          subWayList.push({
            desAddress: item.address,
            navigatDesLocation: item.navigatLocation,
            arriveTime: item.arriveTime,
            nand: item.nand,
            eand: item.eand,
          });
        }
      }
      if (detailRes.transitLineInfosVer && detailRes.transitLineInfosVer.length) {
        for (let item of detailRes.transitLineInfosVer) {
          subWayListVer.push({
            desAddress: item.address,
            navigatDesLocation: item.navigatLocation,
            arriveTime: item.arriveTime,
            nand: item.nand,
            eand: item.eand,
          });
        }
      }

      const lineDetail = {
        data: {
          // 出发导航地址
          navigatSourceLocation: orderGoods.navigatSourceLocation,
          // 出发地址
          source: orderGoods.source,
          // 目的导航地址
          navigatDesLocation: orderGoods.navigatDesLocation,
          // 目的地址
          desAddress: orderGoods.desDtl,
          // 到达时间
          arriveTime: orderScheduler.arriveTime,
          // 途径地址
          subWayList: subWayList,

          // 出发地经度
          nand: orderGoods.nand,
          // 出发地纬度
          eand: orderGoods.eand,
          // 目的地地经度
          nandDes: orderGoods.nandDes,
          // 目的地纬度
          eandDes: orderGoods.eandDes,
        },
        ver: {
          // 出发导航地址（审核）
          navigatSourceLocation: orderGoodsVer.navigatSourceLocation || '',
          // 出发地址（审核）
          source: orderGoodsVer.source || '',
          // 目的导航地址（审核）
          navigatDesLocation: orderGoodsVer.navigatDesLocation || '',
          // 目的地址（审核）
          desAddress: orderGoodsVer.desDtl || '',
          // 到达时间
          arriveTime: orderSchedulerVer.arriveTime || '',
          // 途径地址（审核）
          subWayList: subWayListVer,

          // 出发地经度
          nand: orderGoodsVer.nand,
          // 出发地纬度
          eand: orderGoodsVer.eand,
          // 目的地地经度
          nandDes: orderGoodsVer.nandDes,
          // 目的地纬度
          eandDes: orderGoodsVer.eandDes,
        },

      };
      return lineDetail;
    },
    async getData (detailRes) {
      // 详情数据
      this.orderDetail = {};
      this.lineDetail = {};
      // 重写各个模块的 详情数据，方便和 审核数据 做对比
      this.setBaseData(detailRes);
      if (this.$route.query.type === 'approve' && detailRes && detailRes.orderInfo.orderUpdateState === 2) {
        // 重写各个模块的 审核数据
        this.setBaseVerData(detailRes);
      }
      this.lineDetail = this.setLineDetail(detailRes);
      this.cityCustomerOrders = detailRes.cityCustomerOrders;
      this.cityCustomerOrderVers = detailRes.cityCustomerOrderVers || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-item-inline-box {
  display: flex;
  justify-content: space-between;
  .detail-item-horizontal {
    width: 25%;
    border-right: 1px solid #e0e0e0;
    padding: 0 8px 0 24px;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      border-right: none;
    }
  }
}
.detail-item-title {
  display: flex;
  justify-content: space-between;
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 18px;
  font-weight: 400;
}
</style>

